import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {ActiveOccurrencesFilters} from "@/pages/maintenance/maintenance-dashboard/tabs/active-occurrences/ActiveOccurrencesTable/components/ActiveOccurrencesFilters.tsx";

interface ActiveOccurrencesControlBarProps {
  search: string;
  setSearch: (search: string) => void;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
}

export const ActiveOccurrencesControlBar = ({
  search,
  setSearch,
  filterSets,
  onFilterSetChange,
}: ActiveOccurrencesControlBarProps) => {
  return (
    <ActionBarWrapper
      className="mb-3"
      left={
        <>
          <SearchInput value={search} onChange={setSearch} variant="tableControlBar" />
          <ActiveOccurrencesFilters filterSets={filterSets} onFilterSetChange={onFilterSetChange} />
        </>
      }
    />
  );
};
